export const getSampleIndexFromTimestamp = (startTimestamp: number, endTimestamp: number) => {
  const sampleIndexPerSecond = 200;
  const sampleIndex = Math.round((endTimestamp - startTimestamp) / 1000) * sampleIndexPerSecond;
  
  return sampleIndex;
}

// export const getSampleIndexFromTimestamp = (startTimestamp: number, endTimestamp: number) =>
//   Math.round((endTimestamp - startTimestamp) / 200);
